<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">add_circle</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('mating.Births') }}</h6>
                        <div class="row" style="margin-top: -30px;">                            
                        </div>
                    </div>
                    <div class="table-responsive" style="margin-top: 20px;">                                                
                        <table id="mating-list" class="table table-flush" v-if="tableVisible">
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.UBN') }}</p></th>                                    
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.Date') }}</p></th>                                    
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.Father_animal') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.Mother_animal') }}</p></th>                                    
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.Birth_date') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.No_of_born') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.No_of_alive') }}</p></th>
                                    <th></th>                                    
                                </tr>
                            </thead>                            
                            <tbody>                                                                    
                                <tr v-for="item in births" :key="item.id">
                                    <td class="text-sm font-weight-normal">{{ item.ubn }}</td>
                                    <td class="text-sm font-weight-normal">
                                    {{ item.dateFrom }} {{ $t('mating.To') }} {{ item.dateTo }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                    {{ item.maleAnimalNumber }}<br />
                                    <span class="text-sm text-green" v-if="item.maleLeasedFromUBNId && item.maleLeasedFromUBNId !== $store.state.keeperLocationId">
                                        {{ $t('mating.Male_leased_from_UBN') }} {{ item.maleLeaseUbn }}
                                    </span>
                                    </td>
                                    <td class="text-sm font-weight-normal">{{ item.femaleAnimalNumber }}</td>                                    
                                    <td class="text-sm font-weight-normal">{{ item.birthDate }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.noOfBirth }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.noOfAlive }}</td>
                                    <td>                                       
                                        <div class="float-end me-2" v-if="item.offspringAdded">
                                            <button
                                            :data-id="item.id"
                                            :data-ubnId="item.ubnId"
                                            class="mt-2 mb-0 btn bg-gradient-success btn-sm registeredoffspring-button"
                                            :title="$t('common.Birth')"
                                            >
                                            <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">
                                                visibility
                                            </i>
                                            </button>
                                        </div>
                                        <div class="float-end me-2" v-if="!item.offspringAdded">
                                            <button
                                            :data-id="item.id"
                                            :data-ubnId="item.ubnId"
                                            class="mt-2 mb-0 btn bg-gradient-success btn-sm registernewborn-button"
                                            :title="$t('common.Add_new_born')"
                                            >
                                            <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">
                                                add_business
                                            </i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>                    
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import axios from 'axios';
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";

export default {
    name: 'Birth_index_page',
    components: {
    },
    data() {
        return {
            associationId: '',
            associations: [],
            births: [],
            gets: [],            
            dataTableInstance: null,
            tableVisible: false,
            choicesInstanceAssociation: null
        }
    },
    async mounted() {
        try {            
            this.$store.commit('setShowLoading', true);            
            this.loadBirths();
            
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    methods: {
        async initDataTable() {

            await nextTick();

            const table = document.querySelector("#mating-list");
            if (!table || !table.parentNode) {
                console.warn("Table or its parent not found. Skipping DataTable init.");
                return;
            }

            if (this.dataTableInstance) {
                this.dataTableInstance.destroy();
                this.dataTableInstance = null;
            }

            this.dataTableInstance = new DataTable("#mating-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },  
                    { select: 1, sortable: true },  
                    { select: 2, sortable: true },  
                    { select: 3, sortable: true },  
                    { select: 4, sortable: true },  
                    { select: 5, sortable: true },
                    { select: 6, sortable: true },
                    { select: 7, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search') 
                }
            });  

            table.addEventListener('click', this.handleTableClick);
        },  
        handleTableClick(event) {

            const targetElement = event.target.closest('[data-id]');
            if (!targetElement) return;

            const id = targetElement.getAttribute('data-id');
            if (!id) return;

            const ubnId = targetElement.getAttribute('data-ubnId');
            if (!ubnId) return;

            if (event.target.closest('.edit-button')) {
                this.$router.push({ name: 'Edit Birth', params: { id: id } });
            } else if (event.target.closest('.registernewborn-button')) {
                this.$router.push({ name: 'Register NewBorn', params: { id, ubnId } });
            } else if (event.target.closest('.registeredoffspring-button')) {
                this.$router.push({
                        name: 'Animal',
                        query: {
                            matingId: id
                        }
                    });
            }
        },
        async loadBirths() {
            try {

                let response;
                
                const role = this.$store.state.roleName;
                const ubnId = this.$store.state.keeperLocationId;                

                if (role === 'Admin') {
                    response = await await axios.get("mating/getall");
                } else if (role === 'Keeper' && ubnId) {
                    response = await axios.get(`/mating/getbyubn?ubn=${ubnId}`)
                } else {
                    console.warn('No location assigned for Keeper');
                    return;
                }
                
                this.gets = response.data;

                if (!this.gets?.success) {
                    this.$showError('errors.Contact_system_admin');
                    return;
                }

                //const rawData = Array.isArray(this.gets.data) ? this.gets.data : [];
                const rawData = Array.isArray(this.gets.data) ? [...this.gets.data] : [];
                rawData.sort((a, b) => {
                    const dateA = a.birthDate ? new Date(a.birthDate) : null;
                    const dateB = b.birthDate ? new Date(b.birthDate) : null;

                    if (!dateA && !dateB) return 0;
                    if (!dateA) return 1; // nulls go last
                    if (!dateB) return -1;

                    return dateA - dateB;
                });

                // 1. Destroy DataTable if it exists
                if (this.dataTableInstance) {
                    this.dataTableInstance.destroy();
                    this.dataTableInstance = null;
                }

                // 2. Force table unmount
                this.tableVisible = false;

                // 3. Wait for DOM update to unmount table
                await this.$nextTick();

                // 4. Set matings data
                this.births = rawData;

                // 5. Force table mount
                this.tableVisible = true;

                // 6. Wait for DOM update to mount table
                await this.$nextTick();

                // 7. Init DataTable if data is present
                if (rawData.length > 0) {
                    this.initDataTable();
                } else {
                    this.initDataTable();
                    this.$showSuccess('errors.No_matings_found');
                }

            } catch (e) {
                console.error("Exception occurred in loadBirths()", e);
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        }              
    },
    computed: {        
    }
}
</script>
<style scoped>
    ::v-deep .choices {
        width: auto !important;
        min-width: 270px;
    }

    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }
</style>